import * as React from 'react'
import { getUrlVars } from '../../../utilities/window'

export const trackingTagGeneration = () => {
  const varsResult = getUrlVars()

  if ((varsResult.source || '').toLowerCase() === 'jobs2careers') {
    const img = new Image()
    img.src = '//www.jobs2careers.com/conversion2.php?p=2342'
  }

  // Fluent tracking
  if ((varsResult.source || '').toLowerCase().includes('fluent')) {
    const img = new Image()
    img.src = '//t.afftrackr.com/p.ashx?o=207640&e=862&f=img&t=TRANSACTION_ID'
  }

  // Upward tracking
  if ((varsResult.source || '').toLowerCase().includes('upward')) {
    const img = new Image()
    img.src = '//l5srv.net/AdServer/convert.ads?aid=MjQx'
  }

  // Career builder tracking
  if ((varsResult.source || '').toLowerCase().includes('careerbuilder')) {
    const img = new Image()
    // tslint:disable-next-line:max-line-length
    img.src =
      'https://click.appcast.io/generic-ue8/a7.png?ent=98&e=2713&t=1475263461000'
  }

  // GWM tracking
  if ((varsResult.source || '').toLowerCase().includes('gwm')) {
    const script = document.createElement('script')

    script.src = 'https://dfgyw.com/p.ashx?o=42665&e=4589&f=js&t=TRANSACTION_ID'
    script.async = true

    document.body.appendChild(script)
  }
}

export const rextrkPixel = () =>
  (getUrlVars().source || '').toLowerCase() === 'rex' ? (
    <iframe
      src="//rextrk.com/p.ashx?o=14536&e=945&t=TRANSACTION_ID"
      height="1"
      width="1"
      frameBorder="0"
      title="rextrk pixel"
    />
  ) : null
